module.exports = new __parcel__URL__("workload.10f63c26.svg").toString();